import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentToken } from '../../util';
import { Environment } from '../../typings';
import { ActivatedRoute, Router } from '@angular/router';
import { PreferencesConfirmedApiService } from './preferences-confirmed-api-service';

import { JobPreferencesApiService } from '../job-preferences/job-preferences-api-service';
import { EeocSources } from '../enums';

@Component({
    selector: 'app-preferences-confirmed-page',
    templateUrl: './preferences-confirmed-page.component.html',
    styleUrls: ['./preferences-confirmed-page.component.scss'],
    standalone: false
})
export class PreferencesConfirmedPageComponent {
  @ViewChild('locationSearch') locationSearchElementRef: ElementRef;

  pageTitle: string;
  uuid: string;

  constructor(
    translateService: TranslateService,
    private route: ActivatedRoute,
    private prefsConfirmedApi: PreferencesConfirmedApiService,
    private jobPrefsApi: JobPreferencesApiService,
    protected router: Router,
    @Inject(EnvironmentToken) private environment: Environment
  ) {
    this.pageTitle = translateService.instant('web-style-top-bar.preferences-confirmed');
    this.uuid = this.route.snapshot.paramMap.get('uuid');
    const updatePreferences = this.route.snapshot.queryParamMap.get('updatePreferences') === 'true';

    if (updatePreferences) {
      this.prefsConfirmedApi.confirmJobPreferences(this.uuid).subscribe(() => {
        this.jobPrefsApi.getPersonInfoByUuidRedeployme(this.uuid).subscribe(data => {
          if (data.showEeocForm) {
            this.router.navigate(['eeoc-form', data.eeocFormUUId], { queryParams: { source: EeocSources.REDEPLOYME } });
          }
        });
      });
    }
  }
}
